
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  grid = {};
  url = "/api/fuel/summary/grid?_search=true&rows=20";
  showFilter = false;
  vehicle = {
    _id: "",
  };
  menu1 = false;
  filterUrl = "";
  country = "";
  city = "";
  fuelType = "";
  yearMonth = "";
  page = 1;
  items = ["Petrol", "Diesel", "CNG", "Electric"];

  get loading() {
    return common.loading;
  }

  async mounted() {
    try {
      this.grid = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
  }

  async showPage(page) {
    this.page = page;
    this.grid = await doGet(this.url + this.filterUrl + "&page=" + page);
    common.setLoading(false);
  }

  async clear() {
    this.vehicle = {
      _id: "",
    };
    this.fuelType = "";
    this.yearMonth = "";
    this.page = 1;
    this.search();
  }

  async search() {
    this.filterUrl = "";
    if (this.vehicle && this.vehicle._id)
      this.filterUrl += "&vehicle_id=" + this.vehicle._id;
    if (this.fuelType) this.filterUrl += "&fuelType=" + this.fuelType;
    if (this.yearMonth) this.filterUrl += "&year_month=" + this.yearMonth;
    common.setLoading(true);
    await this.showPage(1);
  }
}
